import { render, staticRenderFns } from "./PartEditTabPart.vue?vue&type=template&id=182d6c0f"
import script from "./PartEditTabPart.vue?vue&type=script&lang=js"
export * from "./PartEditTabPart.vue?vue&type=script&lang=js"
import style0 from "./PartEditTabPart.vue?vue&type=style&index=0&id=182d6c0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports